import React, { useEffect, useState, useRef } from 'react'
import { POSITION_TABLE, ROUTES, ACTION, PAGE_SIZE_OPTIONS, IMAGE_DEFAULT } from 'consts'
import { useHistory, Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import { compare, compareCustom } from 'utils'
import { useTranslation } from 'react-i18next'

//componenets
import FilterDate from 'components/filter-date'
import FilterRegion from 'components/filter-region'

//antd
import {
  Row,
  Button,
  Space,
  Input,
  Table,
  Popconfirm,
  Modal,
  Form,
  InputNumber,
  Upload,
  notification,
  Select,
  Switch,
} from 'antd'

//icons
import { DeleteOutlined, SearchOutlined, PlusOutlined, LogoutOutlined } from '@ant-design/icons'

//apis
import {
  getCategories,
  addCategory,
  deleteCategory,
  updateCategory,
  bulkUpdateCategory,
} from 'apis/category'
import { uploadFile } from 'apis/upload'

export default function Categories() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const typingTimeoutRef = useRef(null)
  const [formCategoryChild] = Form.useForm()
  const KEY_FILTER = 'categoryFilter'
  const filters = localStorage.getItem(KEY_FILTER) && JSON.parse(localStorage.getItem(KEY_FILTER))

  const [categories, setCategories] = useState([])
  const [categoriechildrens, setCategorieChildrens] = useState([])
  const [countCategories, setCountCategories] = useState(0)
  const [loading, setLoading] = useState(false)
  const [paramsFilter, setParamsFilter] = useState(
    filters ? { ...filters } : { page: 1, page_size: 20 }
  )
  const [valueSearch, setValueSearch] = useState(filters ? filters.name || '' : '')

  function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  const _onSearch = (e) => {
    setValueSearch(e.target.value)

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value

      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      paramsFilter.page = 1
      setParamsFilter({ ...paramsFilter })
    }, 750)
  }

  const _deleteCategory = async (category_id) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await deleteCategory([category_id])
      dispatch({ type: ACTION.LOADING, data: false })
      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: t('category_item.delete_item_category_successfully') })
          _getCategories()
          _getCategoriesChildren()
        } else
          notification.error({
            message: res.data.mess || res.data.message || t('category_item.delete_category_failed'),
          })
      } else
        notification.error({
          message: res.data.mess || res.data.message || t('category_item.delete_category_failed'),
        })
    } catch (error) {
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const _getOutCategories = async (category_id) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await updateCategory({ parent_id: -1 }, category_id)
      dispatch({ type: ACTION.LOADING, data: false })
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Lấy nhóm con ra ngoài thành công' })
          _getCategories()
          _getCategoriesChildren()
        } else
          notification.error({
            message: res.data.mess || res.data.message || t('category_item.delete_category_failed'),
          })
      } else
        notification.error({
          message: res.data.mess || res.data.message || t('category_item.delete_category_failed'),
        })
    } catch (error) {
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const _addCategory = async (body) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await addCategory(body)
      dispatch({ type: ACTION.LOADING, data: false })
      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: t('category_item.create_category_successfully') })
          _getCategories()
          _getCategoriesChildren()
        } else
          notification.error({
            message: res.data.mess || res.data.message || t('category_item.create_category_failed'),
          })
      } else
        notification.error({
          message: res.data.mess || res.data.message || t('category_item.create_category_failed'),
        })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const ModalCreateCategoryChild = ({ record }) => {
    const [visibleCreate, setVisibleCreate] = useState(false)
    const [visibleSelect, setVisibleSelect] = useState(false)
    const [IdChildrenSelected, setChildrenSelected] = useState([])

    const toggleCreate = () => {
      setVisibleCreate(!visibleCreate)
    }
    const toggleSelect = () => {
      setVisibleSelect(!visibleSelect)
      var _IdChildrenSelected = []
      record.children_categories.map((category) => {
        _IdChildrenSelected.push(category.category_id)
      })
      setChildrenSelected(_IdChildrenSelected)
    }

    const [imageView, setImageView] = useState('')
    const [fileUpload, setFileUpload] = useState(null)
    const [loading, setLoading] = useState(false)

    const reset = () => {
      formCategoryChild.resetFields()
      setFileUpload(null)
      setImageView('')
      setVisibleCreate(false)
      setVisibleSelect(false)
    }
    const onBulkUpdate = async () => {
      setLoading(true)
      const body = {
        category_ids: IdChildrenSelected,
        parent_id: record.category_id,
      }
      await bulkUpdateCategory(body)
      _getCategories()
      _getCategoriesChildren()
      setLoading(false)
      reset()
      setChildrenSelected([])
    }

    return (
      <>
        <Button type="primary" onClick={toggleCreate}>
          {t('category_item.create_child_category')}
        </Button>
        <Button type="primary" style={{ marginLeft: 5 }} onClick={toggleSelect}>
          Chọn nhóm con
        </Button>

        <Modal
          footer={
            <Row justify="end">
              <Button
                loading={loading}
                type="primary"
                onClick={async () => {
                  await formCategoryChild.validateFields()
                  const dataForm = formCategoryChild.getFieldsValue()
                  setLoading(true)
                  const image = await uploadFile(fileUpload)
                  setLoading(false)

                  const body = {
                    ...dataForm,
                    parent_id: record.category_id,
                    image: image || '',
                    description: dataForm.description || '',
                  }

                  reset()
                  _addCategory(body)
                }}
              >
                {t('common.create')}
              </Button>
            </Row>
          }
          width={500}
          title="Tạo phân loại món con"
          onCancel={reset}
          visible={visibleCreate}
        >
          <div style={{ marginBottom: 15 }}>
            {t('common.image')}

            <Upload
              name="avatar"
              listType="picture-card"
              showUploadList={false}
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              onChange={(info) => {
                if (info.file.status !== 'done') info.file.status = 'done'
                getBase64(info.file.originFileObj, (imageUrl) => setImageView(imageUrl))
                setFileUpload(info.file.originFileObj)
              }}
            >
              {imageView ? (
                <img src={imageView} alt="avatar" style={{ width: '100%' }} />
              ) : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>{t('common.upload')}</div>
                </div>
              )}
            </Upload>
          </div>
          <Form layout="vertical" form={formCategoryChild}>
            <Form.Item
              rules={[{ required: true, message: t('category_item.enter_category_name') }]}
              name="name"
              label={t('category_item.category_name')}
            >
              <Input
                placeholder={t('category_item.enter_category_name')}
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              rules={[{ required: true, message: t('category_item.please_enter_priority') }]}
              name="priority"
              label={t('category_item.priority')}
            >
              <InputNumber
                placeholder={t('category_item.enter_priority')}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          footer={
            <Row justify="end">
              <Button
                loading={loading}
                type="primary"
                onClick={() => {
                  onBulkUpdate()
                }}
              >
                Xác nhận
              </Button>
            </Row>
          }
          width={500}
          title="Chọn nhóm con"
          onCancel={reset}
          visible={visibleSelect}
        >
          <Select
            size="large"
            mode="multiple"
            showSearch
            style={{ width: '100%' }}
            placeholder={`Chọn nhóm con của ${record.name}`}
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => {
              setChildrenSelected(value)
            }}
            value={IdChildrenSelected}
          >
            {categoriechildrens.map((values, index) => (
              <Select.Option value={values.category_id} key={index}>
                {values.name}
              </Select.Option>
            ))}
          </Select>
        </Modal>
      </>
    )
  }

  const _onClearFilters = () => {
    setValueSearch('')
    setParamsFilter({ page: 1, page_size: 20 })
  }

  const _getCategories = async () => {
    try {
      setLoading(true)
      const res = await getCategories({ ...paramsFilter, _creator: true, parent: true })
      console.log(res)
      if (res.status === 200) {
        setCategories(res.data.data)
        setCountCategories(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const _getCategoriesChildren = async () => {
    try {
      setLoading(true)
      const res = await getCategories({ ...paramsFilter, _creator: true, children: true })
      console.log(res)
      if (res.status === 200) {
        setCategorieChildrens(res.data.data)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const _updateCategory = async (body, record) => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })

      const res = await updateCategory(body, record.category_id)
      dispatch({ type: ACTION.LOADING, data: false })
      if (res.status === 200) {
        if (res.data.success) {
          _getCategories()
          _getCategoriesChildren()
          notification.success({ message: t('category_item.update_successfully') })
        } else
          notification.error({
            message: res.data.message || t('category_item.update_fail_please_try_again'),
          })
      } else
        notification.error({
          message: res.data.message || t('category_item.update_fail_please_try_again'),
        })
    } catch (error) {
      dispatch({ type: ACTION.LOADING, data: false })
      console.log(error)
    }
  }

  const columnsParent = [
    {
      title: t('common.image'),
      align: 'center',
      render: (text, record) => (
        <img src={record.image || IMAGE_DEFAULT} alt="" style={{ width: 70, height: 70 }} />
      ),
    },
    {
      title: t('category_item.category_name'),
      align: 'center',
      sorter: (a, b) => compare(a, b, 'name'),
      render: (text, record) => (
        <Link to={{ pathname: ROUTES.CATEGORY, state: record }}>
          {record.name || ''}
          {record.is_default ? ` (${record.is_default && 'Mặc định'})` : ''}
        </Link>
      ),
    },
    {
      title: t('category_item.category_code'),
      align: 'center',
      dataIndex: 'code',
      sorter: (a, b) => compare(a, b, 'code'),
    },
    // {
    //   title: t('common.creator'),
    //   align: 'center',
    //   sorter: (a, b) =>
    //     compareCustom(
    //       a._creator ? `${a._creator.first_name} ${a._creator.last_name}` : '',
    //       b._creator ? `${b._creator.first_name} ${b._creator.last_name}` : ''
    //     ),
    //   render: (text, record) =>
    //     record._creator && `${record._creator.first_name} ${record._creator.last_name}`,
    // },
    // {
    //   title: t('common.create_date'),
    //   align: 'center',
    //   sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
    //   render: (text, record) =>
    //     record.create_date && moment(record.create_date).format('DD/MM/YYYY HH:mm:ss'),
    // },
    {
      title: t('category_item.priority'),
      align: 'center',
      dataIndex: 'priority',
      sorter: (a, b) => compare(a, b, 'priority'),
    },
    {
      title: t('category_item.open_for_sale'),
      align: 'center',
      render: (text, record) => (
        <Switch
          checked={record.is_active}
          onChange={(checked) => _updateCategory({ is_active: checked }, record)}
        />
      ),
    },
    {
      title: t('category_item.is_delivery'),
      align: 'center',
      render: (text, record) => (
        <Switch
          checked={record.is_delivery}
          onChange={(checked) => _updateCategory({ is_delivery: checked }, record)}
        />
      ),
    },
    {
      title: 'Gourmet',
      align: 'center',
      render: (text, record) => (
        <Switch
        checked={record.is_gourmet}
        onChange={(checked) => _updateCategory({ is_gourmet: checked },record)}
        />
      ),
    },
    {
      width: 100,
      title: t('common.action'),
      align: 'center',
      render: (text, record) => (
        <Space size="middle">
          <Popconfirm
            onConfirm={() => _deleteCategory(record.category_id)}
            title={t('category_item.would_you_like_delete_category')}
          >
            <DeleteOutlined style={{ color: 'red', fontSize: 18, cursor: 'pointer' }} />
          </Popconfirm>
        </Space>
      ),
    },
  ]

  const columnsChildren = [
    {
      title: t('common.image'),
      align: 'center',
      render: (text, record) => (
        <img src={record.image || IMAGE_DEFAULT} alt="" style={{ width: 45, height: 45 }} />
      ),
    },
    {
      title: t('category_item.category_name'),
      align: 'center',
      render: (text, record) => (
        <Link to={{ pathname: ROUTES.CATEGORY, state: { ...record, isChildren: true } }}>
          {record.name || ''}
          {record.is_default ? ` (${record.is_default && 'Mặc định'})` : ''}
        </Link>
      ),
    },
    { title: t('category_item.category_code'), align: 'center', dataIndex: 'code' },
    // {
    //   title: t('common.creator'),
    //   align: 'center',
    //   render: (text, record) =>
    //     record._creator && `${record._creator.first_name} ${record._creator.last_name}`,
    // },
    // {
    //   title: t('common.create_date'),
    //   align: 'center',
    //   render: (text, record) =>
    //     record.create_date && moment(record.create_date).format('DD/MM/YYYY HH:mm:ss'),
    // },
    { title: t('category_item.priority'), align: 'center', dataIndex: 'priority' },
    {
      title: t('category_item.open_for_sale'),
      align: 'center',
      key: 'active',
    },
    {
      title: t('category_item.is_delivery'),
      align: 'center',
      key: 'is_delivery',
      render: (text, record) => (
        <Switch
          checked={record.is_delivery}
          onChange={(checked) => _updateCategory({ is_delivery: checked }, record)}
        />
      ),
    },
    {
      title: 'Gourmet',
      align: 'center',
      key: 'is_gourmet',
      render: (text, record) => (
        <Switch
        checked={record.is_gourmet}
        onChange={(checked) => _updateCategory({is_gourmet: checked }, record)}
        />
      )
    },
    {
      title: t('common.action'),
      align: 'center',
      key: 'action',
    },
  ]

  useEffect(() => {
    _getCategories()
    _getCategoriesChildren()

    //save filters to localStorage
    localStorage.setItem(KEY_FILTER, JSON.stringify({ ...paramsFilter }))
  }, [paramsFilter])

  return (
    <div className="card-container">
      <Row
        align="middle"
        justify="space-between"
        style={{ borderBottom: '0.75px solid #BBBCBD', paddingBottom: 15 }}
      >
        <h3 style={{ marginBottom: 0, fontWeight: 700, marginRight: 7 }}>
          {t('category_item.manage_item_category')}
        </h3>
        <Button size="large" type="primary" onClick={() => history.push(ROUTES.CATEGORY)}>
          {t('category_item.create_category_item')}
        </Button>
      </Row>
      <div style={{ margin: '25px 0' }}>
        <Space>
          <Input
            allowClear
            value={valueSearch}
            onChange={_onSearch}
            style={{ width: 350 }}
            prefix={<SearchOutlined />}
            placeholder="Tìm kiếm theo tên phân loại món"
            size="large"
          />
          <FilterRegion
            width_size={400}
            setParamsFilter={setParamsFilter}
            paramsFilter={paramsFilter}
          />
          <Button
            onClick={_onClearFilters}
            type="primary"
            size="large"
            danger
            style={{ display: Object.keys(paramsFilter).length <= 2 && 'none' }}
          >
            {t('common.clear_filter')}
          </Button>
        </Space>
      </div>

      <Table
        expandable={{
          expandedRowRender: (record) => {
            return (
              <div style={{ margin: 25 }}>
                <Row justify="end">
                  <ModalCreateCategoryChild record={record} />
                </Row>
                <Table
                  rowKey="category_id"
                  style={{ width: '100%' }}
                  pagination={false}
                  columns={columnsChildren.map((column) => {
                    if (column.key === 'action')
                      return {
                        ...column,
                        render: (text, recordChildren) => (
                          <Space>
                            <Popconfirm
                              onConfirm={() => _deleteCategory(recordChildren.category_id)}
                              title={t('category_item.would_you_like_delete_category')}
                              okText={t('category_item.ok')}
                              cancelText={t('category_item.cancel')}
                            >
                              <DeleteOutlined
                                style={{ color: 'red', fontSize: 18, cursor: 'pointer' }}
                              />
                            </Popconfirm>
                            <Popconfirm
                              onConfirm={() => _getOutCategories(recordChildren.category_id)}
                              title={'Xác nhận bỏ nhóm con ra khỏi nhóm cha'}
                            >
                              <LogoutOutlined
                                style={{ color: 'red', fontSize: 18, cursor: 'pointer' }}
                              />
                            </Popconfirm>
                          </Space>
                        ),
                      }

                    if (column.key === 'active')
                      return {
                        ...column,
                        render: (text, recordChildren) => (
                          <Switch
                            checked={recordChildren.is_active}
                            onChange={(checked) =>
                              _updateCategory({ is_active: checked }, recordChildren)
                            }
                          />
                        ),
                      }
                    return column
                  })}
                  dataSource={record.children_categories || []}
                  size="small"
                  expandable={{
                    expandedRowRender: (record1) => {
                      return (
                        <div style={{ margin: 25 }}>
                          <Row justify="end">
                            <ModalCreateCategoryChild record={record1} />
                          </Row>
                          <Table
                            rowKey="category_id"
                            style={{ width: '100%' }}
                            pagination={false}
                            columns={columnsChildren.map((column) => {
                              if (column.key === 'action')
                                return {
                                  ...column,
                                  render: (text, recordChildren) => (
                                    <Popconfirm
                                      onConfirm={() => _deleteCategory(recordChildren.category_id)}
                                      title={t('category_item.would_you_like_delete_category')}
                                      okText={t('category_item.ok')}
                                      cancelText={t('category_item.cancel')}
                                    >
                                      <DeleteOutlined
                                        style={{ color: 'red', fontSize: 18, cursor: 'pointer' }}
                                      />
                                    </Popconfirm>
                                  ),
                                }

                              if (column.key === 'active')
                                return {
                                  ...column,
                                  render: (text, recordChildren) => (
                                    <Switch
                                      checked={recordChildren.is_active}
                                      onChange={(checked) =>
                                        _updateCategory({ is_active: checked }, recordChildren)
                                      }
                                    />
                                  ),
                                }

                              return column
                            })}
                            dataSource={record1.children_categories || []}
                            size="small"
                          />
                        </div>
                      )
                    },
                  }}
                />
              </div>
            )
          },
        }}
        pagination={{
          position: POSITION_TABLE,
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          pageSizeOptions: PAGE_SIZE_OPTIONS,
          showQuickJumper: true,
          onChange: (page, pageSize) => setParamsFilter({ page: page, page_size: pageSize }),
          total: countCategories,
        }}
        rowKey="category_id"
        loading={loading}
        dataSource={categories}
        columns={columnsParent}
        style={{ width: '100%' }}
        size="small"
      />
    </div>
  )
}
